import type { FC } from 'react';
import { McpAtMentionMenu } from './McpAtMentionMenu';
import { McpDomainMentionSendBridge } from './McpComposerDomainBadges';
import { McpSlashCommandMenu } from './McpSlashCommandMenu';

/** Composer overlay addons: `/` skills + `@` domain mentions. */
export const McpComposerAddons: FC = () => {
  return (
    <>
      <McpSlashCommandMenu />
      <McpAtMentionMenu />
      <McpDomainMentionSendBridge />
    </>
  );
};
